import { SvgIcon, type SvgIconProps } from '../SvgIcon';

export const RuleOverriddenIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox={'0 0 24 24'} {...props}>
    <path
      d={'M12 15C12.2833 15 12.5212 15.0954 12.7129 15.2871C12.9046 15.4788 13 15.7167 13 16C13 16.2833 12.9046 16.5212 12.7129 16.7129C12.5212 16.9046 12.2833 17 12 17C11.7167 17 11.4788 16.9046 11.2871 16.7129C11.0954 16.5212 11 16.2833 11 16C11 15.7167 11.0954 15.4788 11.2871 15.2871C11.4788 15.0954 11.7167 15 12 15Z'}
      fill={'currentColor'}
    />
    <path d={'M13 7V13H11V7H13Z'} fill={'currentColor'} />
    <path
      d={'M24 12L12 24L0 12L12 0L24 12ZM2.82812 12L12 21.1719L21.1719 12L12 2.82812L2.82812 12Z'}
      fillRule={'evenodd'}
      clipRule={'evenodd'}
      fill={'currentColor'}
    />
  </SvgIcon>
);
